function webLinksAreDifferent(links1, links2) {
    if (!links1 || !links2) return false;
    if (links1.length !== links2.length) return true;
    if (links1.some(link1 => !links2.some(link2 => link1.Type === link2.Type))) return true;
    if (links2.some(link2 => !links1.some(link1 => link2.Type === link1.Type))) return true;
    if (links1.some(link1 => links2.some(link2 => {
      return link1.Type === link2.Type && (link1.Url !== link2.Url || link1.Caption !== link2.Caption);
    }))) return true;
  
    return false;
} 

export default webLinksAreDifferent;